import React from "react"
import { DataTable } from "primereact/datatable"
import { Column } from "primereact/column"
import styles from "../../styles/GenericTable.module.css"

const GenericTable = ({
  data = [],
  columns,
  header,
  filters,
  paginator,
  rows,
  sortField = "date", // Default sort field is "date", can be overridden
  sortOrder = -1, // Default sort order is descending (-1), can be overridden
}) => {
  const safeData = data || []

  const totalRecords = safeData.length

  const [first, setFirst] = React.useState(0)

  const onPage = (event) => {
    setFirst(event.first)
  }

  const startRecord = first + 1
  const endRecord = Math.min(first + rows, totalRecords)
  const footer = `Showing ${startRecord} to ${endRecord} of ${totalRecords} records`

  return (
    <div className={styles["wrapper"]}>
      {header}
      <DataTable
        value={safeData}
        paginator={paginator}
        rows={rows}
        filters={filters}
        footer={footer}
        first={first}
        onPage={onPage}
        emptyMessage="No records found"
        sortField={sortField} // Use sortField, default is "date"
        sortOrder={sortOrder} // Use sortOrder, default is descending (-1)
      >
        {columns.map((col, index) => (
          <Column
            key={index}
            field={col.field}
            header={col.header}
            sortable={col.sortable}
            body={col.body}
          />
        ))}
      </DataTable>
    </div>
  )
}

export default GenericTable
